import {
  Box,
  Card,
  CardContent,
  CardMedia,
  LinearProgress,
  Typography,
} from "@mui/material";
import React from "react";
import useApiEp from "../../../../hooks/useApiEp";

const BrochuresList = ({ user }) => {
  const { data, isLoading } = useApiEp(
    `/user/get-user-brochures?id=${user.username}`
  );
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <Box display="flex" gap={2} flexWrap="wrap">
      {data?.data?.map((item, index) => (
        <Card
          key={index}
          elevation={0}
          sx={{
            width: 260,
            borderRadius: 4,
            border: "1px solid #eef2f6",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            cursor: "pointer",
            textAlign: "center",
            transition:
              "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
            },
          }}
          onClick={() => window.open(item.pdfUrl, "_blank")}
        >
          <CardMedia
            component="img"
            image={item.preview}
            alt={item.title}
            sx={{ height: 160, objectFit: "cover" }}
          />
          <CardContent
            sx={{ padding: 2, "&:last-child": { paddingBottom: 2 } }}
          >
            <Typography variant="h6" color="#1e293b" fontWeight={500} noWrap>
              {item.title}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default BrochuresList;
